var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
function getProduct(){
  var get_prod_data = localStorage.getItem("wishlist products");
  if(get_prod_data!= null){
    var product_data = JSON.parse(get_prod_data);
    $(".wishlist-products .wishlist-product-img").html("");
    $(".custom-wishlist-header").find(".wishlist-count").html(product_data.length);
     

    if(product_data.length > 0){
      $(document).find(".custom-wishlist-header svg").addClass("wishlist-fill");
      $(document).find(".wishlist-header-icon").addClass("wishlist-fill");
    } else {
      $(document).find(".custom-wishlist-header svg").removeClass("wishlist-fill");
      $(document).find(".wishlist-header-icon").removeClass("wishlist-fill");
    }
    
    product_data.forEach(function(val) {
         setTimeout(function() {
           $('#wish_list-'+val).prop('checked', true);
           $('#wish_list-'+val).addClass("wishlist-fill");
         }, 500);
        //  $.ajax({
        //     type: 'GET',
        //     url: '/cart.js',
        //     cache: false,
        //     dataType: 'json',
        //     success: function(cart) {
        //       $(cart.items).each(function (index, item) {
        //         if(val == item.handle){
        //           product_data = $.grep(product_data, function(value) {
        //             return value != item.handle;
        //           });
        //           localStorage.setItem('wishlist products', JSON.stringify(product_data));
        //           $(".custom-wishlist-header .wishlist-count").html(product_data.length);
        //         }
        //       });
        //     }
        // });
      
        $.ajax({
          url: "/products/" + val + ".js",
          dataType: "json",
          success: function(product) {
            var wishlist_html = 
            '<div class="wishlist-append-main" id="main_wish_list-'+ product.handle +'">\n'+
              '<a href='+ product.url +'><img width="300" height="300" src='+ product.featured_image +' class="wishlist_img" alt='+ product.title +'></a>\n'+
              '<div class="wishlist-card-info">\n'+
              '<h3><a href='+ product.url +'>'+ product.title +'</a></h3>\n'+
              '<p class="wishlist-price">'+ Shopify.formatMoney(product.variants[0].price) +'</p>';;
                if(product.variants[0].compare_at_price > product.variants[0].price){
                  wishlist_html += '<del class="wishlist-compare-price">'+ Shopify.formatMoney(product.variants[0].compare_at_price) +'</del>';
                }
  
            wishlist_html += '<div class="wishlist-variant-option"><select class="wishlist-product-select productdata-'+product.id+'" style="display:none;"></select>';
  
            $(product.options).each(function (index, option) {
            var option_name = option.name;
             wishlist_html += '<div class="option-name">'+ option_name+'</div><div class="variant-option-global">';
  
            $(option.values).each(function (i, value) {
              var variant_img;
              var variant_price;
              var variant_compare_price;
              $(".wishlist-product-select").html("");
  
              var variant_img = "";
              var variant_position = 0;
              $(product.variants).each(function (index, variant) {
                
                if (variant.title.includes(value) && variant.featured_image) {
                  variant_img = variant;
                }
                setTimeout(function() {
                  if(product.variants[0].title == 'Default Title' || variant.featured_image == null){
                    $('.productdata-'+product.id).append('<option class="product-select-option" var_price="'+ variant.price +'" data-quickprice="'+ variant.price +'" data-quickcprice="'+ variant.compare_at_price +'" data_title="' + variant.title + '" value="' + variant.id + '">' + variant.title + '</option>');
                    $('.productdata-'+product.id).parent().hide();
                  }else{
                    $('.productdata-'+product.id).append('<option class="product-select-option" data-position="'+ variant.featured_image.position +'" var_price="'+ variant.price +'" data-quickprice="'+ variant.price +'" data-quickcprice="'+ variant.compare_at_price +'" data_title="' + variant.title + '" value="' + variant.id + '">' + variant.title + '</option>');
                    $('.productdata-'+product.id).parent().show();
                  }
                }, 200);  
              });
              if (variant_img && variant_img.featured_image) {
                variant_img = variant_img.featured_image.src;
              }
   
              wishlist_html += '<div class="option-input">';
                if(i == 0){
                   wishlist_html += '<input checked="checked" type="radio" class="color-img" id="'+ i +'-label_'+ option_name +'-'+ product.id +'" name="'+ option_name +'-'+ product.id +'" value="'+ value +'" tabindex="0">';
                }else{
                   wishlist_html += '<input type="radio" class="color-img" id="'+ i +'-label_'+ option_name +'-'+ product.id +'" name="'+ option_name +'-'+ product.id +'" value="'+ value +'" tabindex="0">';
                }
                wishlist_html += '<label for="'+ i +'-label_'+ option_name +'-'+ product.id +'">'+ value +'</label>';
                if(option_name == "Color"){
                  if(variant_img != ""){
                  wishlist_html += '<img src="'+ variant_img +'" width="50" height="50" alt="'+ value +'" title="'+ value +'">';
                  }
                }
             wishlist_html += '</div>';
            });
            wishlist_html += '</div>';
          });
             wishlist_html += '</div><div class="wishlist-remove">\n'+
              '<input type="checkbox" id="wish_list-'+ product.handle +'" class="wishlist-checkbox-remove" name="wishlist" value="'+ product.handle +'">\n'+
              '<label for="wish_list-'+ product.handle +'">\n'+
              '<img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/delete-forever.png" alt="delete-forever"/>\n'+
              '</label>\n'+
              '</div>\n'+
              '<button type="button" class="add-to-cart-wishlist button button--small" data-wish-id="wish_list-'+ product.handle +'" ><span>Add to cart</span></button>\n'+
              '</div>\n'+
              '</div>';
            $(".wishlist-append").append(wishlist_html);
          },
          error: function (data) {
            if (data.status == 422) {
            alert("Selected product from bundle is already soldout!");
          }
          }
      });
    });
  }
}
function addProduct(prod_handle = "",obj){
  var products = [];
  var is_available = false;
  var get_prod_data_new = localStorage.getItem("wishlist products");

  if(get_prod_data_new != null){
     var product_data = JSON.parse(get_prod_data_new);
      product_data.forEach(function(val) { 
        if(val == prod_handle){
          is_available = true;
        }else{
          products.push(val);
        }
      });
      if(!is_available){
        products.push(prod_handle);
        obj.prop("checked", true);
        obj.addClass("wishlist-fill");
        obj.parents("body").find(".wishlist-header-icon").addClass("wishlist-fill");
      } else {
        obj.prop("checked", false);
         obj.removeClass("wishlist-fill");
         obj.parents("body").find(".wishlist-header-icon").removeClass("wishlist-fill");
      }
  }else{
    if(!is_available){
      obj.prop("checked", true);
      obj.addClass("wishlist-fill");
      obj.parents("body").find(".wishlist-header-icon").addClass("wishlist-fill");
    }else{
      obj.removeClass("wishlist-fill");
      obj.parents("body").find(".wishlist-header-icon").removeClass("wishlist-fill");
    }
     products.push(prod_handle);
  }
  $(".custom-wishlist-header").find(".wishlist-count").html(products.length);
  localStorage.setItem('wishlist products', JSON.stringify(products));
}
function removeProduct(event){
  let products = JSON.parse(localStorage.getItem('wishlist products')) || [];
  if (products.indexOf(event.target.value) !== -1) {
    products.splice(products.indexOf(event.target.value), 1);
    localStorage.setItem('wishlist products', JSON.stringify(products));
    $(event.target).closest('.wishlist-append-main').remove();
  }
  wishlistCount();
}
function wishlistCount(){
  var wishlist_header_count = $(".wishlist-products .wishlist-append-main").length;
  $(".custom-wishlist-header .wishlist-count").html(wishlist_header_count);
}
$(document).ready(function() {
  getProduct();
  $(document).on("click", ".wishlist-remove .wishlist-checkbox-remove", function (event) {
    removeProduct(event);
  });
  $(document).on("change", ".wishlist-btn input[type=checkbox]", function (event) {
    wishlistCount();
  });
  $(document).on("change", ".wishlist-variant-option .option-input input[type='radio']", function () {
     var variant_title = '';
        $(this).parents('.wishlist-variant-option').find('.variant-option-global').each(function( index ) {
          variant_title +=  " / "+$(this).find('input[type="radio"]:checked').val();
        });
        variant_title = variant_title.slice(3);
        var var__price = $(this).parents('.wishlist-variant-option').find('.wishlist-product-select option[data_title="'+variant_title+'"]').attr('data-quickprice');
        var var_compare_price = $(this).parents('.wishlist-variant-option').find('.wishlist-product-select option[data_title="'+variant_title+'"]').attr('data-quickcprice');
        $(this).parents(".wishlist-append-main").find(".wishlist-price").text(Shopify.formatMoney(var__price));
        if(var_compare_price != 'null'){
          $(this).parents(".wishlist-append-main").find(".wishlist-compare-price").text(Shopify.formatMoney(var_compare_price));
        } else{
          $(this).parents(".wishlist-compare-price").html("");
        }

  });
  $(document).on('click','.add-to-cart-wishlist', function() {
    var variant_title = '';
    var data_wish_id = $(this).attr("data-wish-id");
     
    $(this).parent('.wishlist-card-info').find('.wishlist-variant-option .variant-option-global').each(function( index ) {
      variant_title +=  " / "+$(this).find('input[type="radio"]:checked').val();
    });
    variant_title = variant_title.slice(3);
    var variant_id = $(this).parent('.wishlist-card-info').find('.wishlist-product-select option[data_title="'+variant_title+'"]').attr('value');
    var data = {
      "quantity": 1,
      "id": variant_id
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) {
        var is_drawer_enabled = $("body").data("drawerenabled");
        /* product removed from wishlist page when add product to cart uncomment below 2 line  start */
        // $("#"+data_wish_id).click();
        // $("#main_"+data_wish_id).hide();
         /* product removed from wishlist page when add product to cart end */
        if(is_drawer_enabled == true){
          cartDrawerView();
        }else {
          window.location = "/cart";
        }
      },
      error: function (data) {
        if (data.status == 422) {
          alert("Selected product is already soldout!");
        }
      }
    });
  });
  function cartDrawerView() {
    $.ajax({
      url: '/?section_id=mini-cart',
      type: 'GET',
      dataType: 'html',
      success:function(carthtml) {
        $('mini-cart').html($(carthtml).html());
        var cart_item_count = $(carthtml).find("ul.mini-cart__navigation li").length;
        $(".cart-count-bubble").html('<span aria-hidden="true">'+ cart_item_count +'</span><span class="visually-hidden">'+ cart_item_count +' items</span>');
          $("body").addClass("mini-cart--open");
          $(document).find(".cart-drawer-container").addClass("menu-opening");
          $(document).find(".cart-drawer-container").attr("open", "open");
        }
     });
  }
  $(document).on("click", ".wishlist-btn", function (event) {
     event.preventDefault();
    var obj= $(this).find('.wishlist-checkbox');
    var prod_handle = $(this).data("wishlist-handle");
    addProduct(prod_handle,obj); 

    var header_wishcount = $(document).find(".custom-wishlist-header .wishlist-count").text();
    if(header_wishcount > 0){
      $(document).find(".custom-wishlist-header svg").addClass("wishlist-fill");
      $(document).find(".wishlist-header-icon").addClass("wishlist-fill");
    } else {
      $(document).find(".custom-wishlist-header svg").removeClass("wishlist-fill");
      $(document).find(".wishlist-header-icon").removeClass("wishlist-fill");
    }
  });
});



